// List of all action.type Constants
export const USER_DETAILS_LOADING = "USER_DETAIL_LOADING";
export const USER_DETAILS_SUCCESS = "USER_DETAIL_SUCCESS";
export const USER_DETAILS_FAILED = "USER_DETAIL_FAILED";
export const RESET_USER_DETAILS = "RESET_USER_DETAILS";
export const PUNCH_DETAILS_SUCCESS = "PUNCH_DETAILS_SUCCESS";

// AUTH
export const AUTH_DETAILS_LOADING = "AUTH_DETAIL_LOADING";
export const AUTH_DETAILS_SUCCESS = "AUTH_DETAIL_SUCCESS";
export const AUTH_DETAILS_FAILED = "AUTH_DETAIL_FAILED";
export const RESET_AUTH_DETAILS = "RESET_AUTH_DETAILS";
export const SET_AUTH = "SET_AUTH";
export const IMT_ROLE_DETAILS_LOADING = "IMT_ROLE_DETAILS_LOADING";
export const IMT_ROLE_DETAILS_FAILED = "IMT_ROLE_DETAILS_FAILED";
export const IMT_ROLE_DETAILS_SUCCESS = "IMT_ROLE_DETAILS_SUCCESS";

// APP CONFIG Constants for action.type
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const ACTIVITY_GROUP_DETAILS_SUCCESS = "ACTIVITY_GROUP_DETAILS_SUCCESS";
export const JOB_FAMILIES_DETAILS_SUCCESS = "JOB_FAMILIES_DETAILS_SUCCESS";
export const EXCEPTIONS_DETAILS_SUCCESS = "EXCEPTIONS_DETAILS_SUCCESS";
export const LOCATIONS_DETAILS_SUCCESS = "LOCATIONS_DETAILS_SUCCESS";
export const COUNTRY_DETAILS_SUCCESS = "COUNTRY_DETAILS_SUCCESS";
export const MANAGER_EMAIL_LOOKUP_SUCCESS = "MANAGER_EMAIL_LOOKUP_SUCCESS";
export const PROJECTS_DETAILS_SUCCESS = "PROJECTS_DETAILS_SUCCESS";
export const TRANSLATION_DETAILS_SUCCESS = "TRANSLATION_DETAILS_SUCCESS";
export const MANAGER_COST_CENTER_DATA_SUCCESS = "MANAGER_COST_CENTER_DATA_SUCCESS";

export const PUNCH_ENTRY_LOADING = "PUNCH_ENTRY_LOADING";
export const RESET_ID_NOTIFICATION = "RESET_ID_NOTIFICATION";

export const SET_DASHBOARD_DISTRICTS = "SET_DASHBOARD_DISTRICTS";
export const SET_DASHBOARD_BUILDINGS = "SET_DASHBOARD_BUILDINGS";
export const SET_DASHBOARD_MANAGER = "SET_DASHBOARD_MANAGER";
export const SET_DASHBOARD_APH_DISTRICT = "SET_DASHBOARD_APH_DISTRICT";

// REVIEW PAGE ACTIONS CONSTANTS

export const SELECTED_WORKER_ON_REVIEW = "SELECTED_WORKER_ON_REVIEW";
export const SELECTED_WEEK_ON_REVIEW = "SELECTED_WEEK_ON_REVIEW";
export const SELECTED_MANAGER_ON_REVIEW = "SELECTED_MANAGER_ON_REVIEW";
export const SELECTED_TEAM_ON_REVIEW = "SELECTED_TEAM_ON_REVIEW";

// REPORT PAGE ACTIONS CONSTANTS
export const SELECTED_MONTH_ON_REPORT = "SELECTED_MONTH_ON_REPORT";

// DSC PAGE ACTION TYPES

export const DSC_LOAD_LOCATIONS_DATA = "LOAD_LOCATIONS_DATA";
export const DSC_DRAWER_STATE = "DSC_DRAWER_STATE";

export const PROJECT_DETAILS_BYCOUNTRY = "PROJECT_DETAILS_BYCOUNTRY";
export const MANAGE_WORKERS_FILTERS_LIST = "MANAGE_WORKERS_FILTERS_LIST";
export const REPORT_VIEW_FILTERS_LIST = "REPORT_VIEW_FILTERS_LIST";
export const TRANSPORT_DETAILS_FILTERS_LIST = "TRANSPORT_DETAILS_FILTERS_LIST";
export const ALL_PUNCH_VIEW_FILTERS_LIST = "ALL_PUNCH_VIEW_FILTERS_LIST";
export const MANAGE_ACTIVITY_GROUP_FILTERS_LIST =
  "MANAGE_ACTIVITY_GROUP_FILTERS_LIST";

// Locations Action Types

export const SAVE_DEVICE_LOCATION = "SAVE_DEVICE_LOCATION";

// Remote Config Action Types
export const UPDATE_CONFIG = "UPDATE_CONFIG";
export const CONFIG_LOADING = "CONFIG_LOADING";
export const WORKDAY_CONFIG_SUCCESS = "WORKDAY_CONFIG_SUCCESS"

// List of all action.type Constants
export const WORKER_DETAILS_LOADING = "WORKER_DETAILS_LOADING";
export const WORKER_DETAILS_SUCCESS = "WORKER_DETAIL_SUCCESS";
export const WORKER_DETAILS_FAILED = "WORKER_DETAIL_FAILED";
export const RESET_WORKER_DETAILS = "RESET_WORKER_DETAILS";
export const WORKER_ROLES_LOADING = "WORKER_ROLES_LOADING";
export const WORKER_ROLES_SUCCESS = "WORKER_ROLES_SUCCESS";
export const WORKER_ROLES_FAILED = "WORKER_ROLES_FAILED";
export const WORKER_SCHEDULE_SUCCCESS = "WORKER_SCHEDULE_SUCCCESS";
export const ROLE_UPDATE = "ROLE_UPDATE";

// User errors
export const USER_ERRORS = {
  NOT_FOUND: "no-user",
  DELETED: "no-user",
  INACTIVE: "inactive",
  PUNCH_DISABLED: "punch-disabled",
  UNABLE_TO_LOAD: "loading-error",
};
